import OpenAPIClientAxios from 'openapi-client-axios';
import definition from '@stefna/checkit-openapi-specification/dist/schema.json';

const key = process.env.ACCESS_TOKEN;

let server;
if (process.env.STAGING) {
  server = 'staging';
}
else {
  server = process.env.PROD ? 'production' : 'staging';
}

const api = new OpenAPIClientAxios({
  definition,
  withServer: server,
  validate: true,
  axiosConfigDefaults: {
    headers: {
      'X-Api-Key': key,
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
});

api.init();

export default api;
